import { Element } from "react-scroll";

export default function SuccessSection() {
  return (
    <Element className="section section--success" name="success">
      <div className="section__head">
        <h1>Success Highlights</h1>
        <p>
          Key achievements highlighting my product-focused UI/UX and frontend expertise
        </p>
      </div>

      <div className="grid-container grid-container--columns">
        <div className="section--success__item">
          <h2>+20</h2>
          <h3>Completed Projects</h3>
          <p>
            From landing pages to full-featured web apps, each project enhanced my skills in crafting user-focused interfaces.
          </p>
        </div>

        <div className="section--success__item">
          <h2>+25</h2>
          <h3>Satisfied Clients</h3>
          <p>
            Delivered polished, responsive, and intuitive UI experiences that meet client goals and delight users.
          </p>
        </div>

        <div className="section--success__item">
          <h2>+85</h2>
          <h3>HTML Templates</h3>
          <p>
            Developed and optimized custom templates emphasizing clean design, usability, and performance.
          </p>
        </div>
      </div>
    </Element>
  );
}
